import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-editlabel',
  templateUrl: './editlabel.component.html',
  styleUrls: ['./editlabel.component.css']
})
export class EditLabelComponent implements OnInit { 

  constructor(   private activeModal:NgbActiveModal,) { }
  submitted=false;
  @Input() label:any;
  ngOnInit() {
  }
  close(){
    this.activeModal.close();
  }

  Accept(){
    this.submitted=true;


  }
}
